module.exports = __webpack_public_path__ + "static/media/cover-hot.3dc81969.png";